import React from 'react'

import Layout from '../components/Layout'
import SEO from '../components/Seo'
import Divider from '../components/Divider'

import HeroSection from '../components/home/HeroSection'
import RealTimeSection from '../components/home/RealTimeSection'
import CDPSection from '../components/home/CDPSection'
import CombiningSection from '../components/home/CombiningSection'

import CustomerSection from '../components/comoon/CustomerSection'
import CustomersNumbersSection from '../components/comoon/CustomerNumbersSection'
import TabSection from '../components/comoon/TabSection'
import IntegrationsSection from '../components/comoon/IntegrationsSection'
import TestimonialsSection from '../components/comoon/TestimonialsSection'
import ContactSection from '../components/comoon/ContactSection'

const IndexPage = () => {
  return (
    <Layout>
      <SEO title="Home" />
      <HeroSection />
      <CustomerSection />
      <RealTimeSection />
      <CDPSection />
      <CombiningSection />
      <CustomersNumbersSection />
      <TabSection type="home" fiveItems />
      <IntegrationsSection />
      <Divider />
      <TestimonialsSection home />
      <ContactSection />
    </Layout>
  )
}

export default IndexPage
